import styled from 'styled-components';

export const StyledHeader = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  background-color: var(--secondary-color);
  z-index: 1000;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);

  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    max-width: 1200px;
    margin: 0 auto;
  }
  
  @media (max-width: 480px) {
    .container {
      padding: 10px 15px;
    }
  }
`;

export const Logo = styled.div`
  a {
    cursor: pointer;
  }
  img {
    height: 100px;
  }
  
  @media (max-width: 480px) {
    img {
      height: 70px;
    }
  }
`;

export const Nav = styled.nav`
  display: flex;
  align-items: center;
`;

export const Menu = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;

  @media (max-width: 768px) {
    display: none;

    &.active {
      display: flex;
      flex-direction: column;
      position: absolute;
      top: 70px;
      left: 0;
      right: 0;
      width: 100vw; /* ← evita estouro em mobile */
      background-color: var(--secondary-color);
      padding: 20px;
      z-index: 999;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
      overflow-x: hidden;
    }
  }

  @media (max-width: 480px) {
    &.active {
      top: 60px;
      padding: 15px;
    }
  }
`;


export const MenuItem = styled.li`
  margin-left: 30px;

  a {
    cursor: pointer;
  }

  @media (max-width: 992px) {
    margin-left: 20px;
  }

  @media (max-width: 768px) {
    margin: 0 0 15px 0;
    width: 100%;
    text-align: center;
    
    &:last-child {
      margin-bottom: 0;
    }
  }

  a {
    color: var(--light-text);
    font-weight: 500;
    position: relative;
    text-decoration: none;
    transition: all 0.3s ease;
    display: block;
    padding: 5px 0;

    &::after {
      content: '';
      position: absolute;
      bottom: -5px;
      left: 0;
      width: 0;
      height: 2px;
      background-color: var(--primary-color);
      transition: all 0.3s ease;
    }

    &:hover::after {
      width: 100%;
    }
    &.active::after {
  width: 100%;
  
}

    
    @media (max-width: 768px) {
      padding: 8px 0;
      font-size: 1.1rem;
    }
  }
`;

export const MobileMenuIcon = styled.div`
  display: none;
  width: 30px;
  height: 20px;
  position: relative;
  cursor: pointer;

  @media (max-width: 768px) {
    display: block;
  }

  span {
    position: absolute;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: var(--light-text);
    transition: all 0.3s ease;
  }

  span:nth-child(1) {
    top: 0;
  }

  span:nth-child(2) {
    top: 9px;
  }

  span:nth-child(3) {
    bottom: 0;
  }

  &.open span:nth-child(1) {
    transform: rotate(45deg);
    top: 9px;
  }

  &.open span:nth-child(2) {
    opacity: 0;
  }

  &.open span:nth-child(3) {
    transform: rotate(-45deg);
    bottom: 9px;
  }
`;

export const SiteControls = styled.div`
  display: flex;
  align-items: center;
  margin-left: 30px;

  @media (max-width: 768px) {
    margin-left: 15px;
  }
  
  @media (max-width: 480px) {
    margin-left: 10px;
  }
`;

export const ThemeToggle = styled.div`
  position: relative;
  width: 60px;
  height: 30px;
  border-radius: 15px;
  background-color: var(--secondary-color);
  cursor: pointer;
  margin-right: 15px;
  overflow: hidden;
  animation: borderGlow 3s infinite;

  &::before {
    content: '';
    position: absolute;
    top: 3px;
    left: 3px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: var(--primary-color);
    transition: all 0.3s ease;
    transform: translateX(${props => props.theme === 'light' ? '30px' : '0px'});
  }

  .icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    font-size: 14px;
    color: var(--light-text);
  }

  .icon-moon {
    left: 8px;
  }

  .icon-sun {
    right: 8px;
  }

  @keyframes borderGlow {
    0% {
      box-shadow: 0 0 5px rgba(255, 107, 0, 0.3);
    }
    50% {
      box-shadow: 0 0 20px rgba(255, 107, 0, 0.5);
    }
    100% {
      box-shadow: 0 0 5px rgba(255, 107, 0, 0.3);
    }
  }
  
  @media (max-width: 480px) {
    width: 50px;
    height: 26px;
    margin-right: 10px;
    
    &::before {
      width: 20px;
      height: 20px;
      transform: translateX(${props => props.theme === 'light' ? '24px' : '0px'});
    }
    
    .icon {
      font-size: 12px;
    }
  }
`;

export const LanguageSelector = styled.div`
  position: relative;
`;

export const LanguageButton = styled.button`
  display: flex;
  align-items: center;
  color: var(--light-text);
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  animation: borderGlow 3s infinite;
  padding: 5px 10px;
  border-radius: 4px;

  .language-icon {
    display: none;
  }

  .chevron-icon {
    margin-left: 5px;
  }

  @media (max-width: 480px) {
    font-size: 12px;
    padding: 5px 8px;

    .language-icon {
      display: inline-block;
      margin-right: 5px;
    }

    span {
      display: none;
    }

    .chevron-icon {
      margin-left: 0;
    }
  }
`;

export const LanguageDropdown = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background-color: var(--secondary-color);
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  padding: 10px 0;
  min-width: 120px;
  display: none;
  z-index: 10;

  &.active {
    display: block;
  }

  a {
    display: block;
    padding: 8px 15px;
    color: var(--light-text);
    text-decoration: none;
    transition: all 0.3s ease;

    &:hover {
      background-color: rgba(255, 107, 0, 0.1);
      color: var(--primary-color);
    }
  }
  
  @media (max-width: 480px) {
    min-width: 100px;
    right: -10px;
    
    a {
      padding: 8px 12px;
      font-size: 13px;
    }
  }
`;
